var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZoomIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.4386 46.9654L34.2262 37.753C32.4952 38.8429 30.4549 39.4827 28.2587 39.4827C22.0593 39.4827 17.0347 34.4581 17.0347 28.2587C17.0347 22.0592 22.0593 17.0346 28.2587 17.0346C34.4581 17.0346 39.4828 22.0592 39.4828 28.2587C39.4828 30.4548 38.8418 32.4964 37.753 34.2261L46.9655 43.4386L43.4386 46.9654ZM28.2587 36.9885C33.0713 36.9885 36.9885 33.0725 36.9885 28.2587C36.9885 23.4448 33.0713 19.5288 28.2587 19.5288C23.4461 19.5288 19.5289 23.4448 19.5289 28.2587C19.5289 33.0725 23.4461 36.9885 28.2587 36.9885Z",
    fill: "currentcolor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9681 28.968H31.0961V27.5493H28.9681V25.4213H27.5494V27.5493H25.4214V28.968H27.5494V31.096H28.9681V28.968Z",
    fill: "currentcolor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomIn);
export default __webpack_public_path__ + "static/media/zoomIn.77faa4ac.svg";
export { ForwardRef as ReactComponent };